import config from "config/config";
import { getToken } from "js/formatting/getToken";

let retryApi = 1;

export async function getPolicyDetails(contractId, userId = "") {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      contractId: contractId,
      userId: `${userId}`,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/policy",
    options
  );
  const retryApiCount = parseInt(config.RETRY_API_COUNT);
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();

    const policyDetails = JSON.parse(data?.policyDetails);
    if (policyDetails?.gXdpApi?.success) {
      retryApi = 1;
      return {
        ...policyDetails.gXdpApi.gIdpPayLoad.policyHolder.policies[0],
        sourceSystemName:
          policyDetails?.gXdpApi?.gIdpPayLoad?.addOnProperties
            ?.sourceSystemName,
        ownerTypeMatch: data?.ownerTypeMatch,
        // assigning streams and agentStatusInfo here so that it will be part of the object
        streams:
          policyDetails.gXdpApi.gIdpPayLoad.policyHolder.policies[0].payment,
        agentStatusInfo: data.agentStatusInfo,
        ownerDeathClaimExists: data?.ownerDeathClaimExists,
      };
    } else if (retryApi < retryApiCount) {
      retryApi++;
      return getPolicyDetails(contractId);
    } else if (retryApi === retryApiCount) {
      retryApi = 1;
      return "Error";
    }
    return;
  }
}
